import { render, staticRenderFns } from "./ClientTypePopup.vue?vue&type=template&id=52bbf790&scoped=true"
import script from "./ClientTypePopup.vue?vue&type=script&lang=js"
export * from "./ClientTypePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bbf790",
  null
  
)

export default component.exports